<template>
  <!--登录框架-->
    <div class="loginForm">
      <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
        <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
          登录
        </span>
        <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
          <a href="javascript:;" @click="close">
            <i class="el-icon-close"></i>
          </a>
        </span>
      </div>
      <div style="width: 300px;margin: 0 auto;">
        <!--登录input框-->
        <!--普通登录input框-->
        <div id="ptlogin">
          <el-form :model="loginForm" ref="loginForm" :rules="rules" style="margin-top: 40px;">
            <el-form-item prop="username">
              <el-input type="text" v-model="loginForm.username" placeholder="用户名 / 邮箱号 / 手机号">
                <template slot="prepend"><i class="el-icon-user" style="font-size: 20px; color: #000000;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="text" v-model="loginForm.password" placeholder="密码" show-password>
                <template slot="prepend"><i class="el-icon-lock" style="font-size: 20px;color: #000000;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input type="text" v-model="loginForm.code" placeholder="验证码" @keyup.enter.native="clickLogin">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <a href="javascript:;" slot="append" @click="getlogincode">
                  <img :src="logincode.img" alt=" " style="width: 80px;height: 33px;" >
                </a>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" style="width: 300px;" @click="clickLogin">登&nbsp;&nbsp;&nbsp;录</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--手机登录input框-->
        <div id="phonelogin" style="display: none;">
          <el-form :model="phoneloginForm" style="margin-top: 40px;">
            <el-form-item prop="phones">
              <el-input type="text" v-model="phoneloginForm.phone" placeholder="手机号">
                <template slot="prepend"><i class="el-icon-user" style="font-size: 20px; color: #000000;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="codes">
              <el-input type="text" v-model="phoneloginForm.codes" placeholder="验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <a href="javascript:;" slot="append" @click="getlogincode">
                  <img :src="logincode.img" alt=" " style="width: 80px;height: 33px;" >
                </a>
              </el-input>
            </el-form-item>
            <el-form-item prop="phonecode">
              <el-input type="text" v-model="phoneloginForm.code" placeholder="短信验证码">
                <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
                <el-button slot="append" size="mini" @click="getPhoneCode" :disabled="phonebutton_tof">{{phonecontent}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" style="width: 300px;" @click="phone_login_re">登&nbsp;&nbsp;&nbsp;录</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--其他登录方式-->
        <div style="width: 300px;overflow: hidden;margin: 0 auto;margin-bottom: 20px;">
          <span style="font-size: 14px;color: #c6c6c6;">———————其他登录方式———————</span>
          <div style="margin: 0 auto;margin-top: 5px; width: 300px;font-size: 14px;text-align: center;">
            <span>
              <a href="javascript:;" style="color: #000000;">
                <img src="@/assets/icon_QQ.png" alt=" " width="35px">QQ登录
              </a>
              <a href="javascript:;" style="color: #000000;">
                <img src="@/assets/icon_weixin.png" alt=" " width="32px">微信登录
              </a>
              <a href="javascript:;" style="color: #000000;" @click="gotoQitaLogin('phone')">
                <i class="iconfont iconptshouji" style="font-size: 40px;color: #136dff;"></i>手机号登录
              </a>
            </span>
          </div>
        </div>
      </div>
      <div style="height: 50px;background-color: #f7f7f7;" id="ptlogin1">
        <span style="float: left;margin-left: 20px;line-height: 50px;font-size: 14px;">
          <a href="javascript:;" style="color: #415bec;" @click="openPasswordMain">忘记密码？</a>
        </span>
        <span style="float: right;margin-right: 20px;line-height: 50px;font-size: 14px;">
          <a href="javascript:;" style="color: #999999;" @click="openregister">没有账号？免费注册 ></a>
        </span>
      </div>
      <div style="height: 50px;background-color: #f7f7f7;display: none;" id="other">
        <span style="float: left;margin-left: 20px;line-height: 50px;font-size: 14px;">
          <a href="javascript:;" style="color: #415bec;" @click="gotoQitaLogin('back')">返回</a>
        </span>
      </div>

      <div style="text-align: left;">
        <xieyiCheck ref="childxieyiCheck" @Father_updateChcke="update_check"></xieyiCheck>
      </div>

    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import {codeAPI} from '@/api/codeAPI'
  import xieyiCheck from '@/components/LoginPage/xieyiCheck.vue'//是否确认协议
export default {
  components: {
    'xieyiCheck': xieyiCheck,
  },
  data () {
    var Username = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var Password = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var Code = (rule, value, callback) => {
      let PD = eval(/^\d+$/);
      let code=this.logincode.logincode;
      if(PD.test(code)){
        if (value.length === 0) {
          callback(new Error('请输入验证码'))
        } else if(code*1!==value*1){
          callback(new Error('验证码错误'))
        } else {
          callback()
        }
      }else{
        if (value.length === 0) {
          callback(new Error('请输入验证码'))
        } else if(code.toUpperCase()!==value.toUpperCase()){
          callback(new Error('验证码错误'))
        } else {
          callback()
        }
      }
    }
    return {
      checked:false,//协议确认，
      //用户密码前端salt
      usersalt:'havetorich',
      //用户相关信息
      UserInfor:{
        photo:'',
        name:'',
        id:'',
        token:'',
        email:'',
        phone:'',
        sex:'',
        signature:'',
        shop_type:'',
      },
      loading: false,   //登陆加载效果
      //页面定位
      activeIndex: this.$route.path,
      //登录信息
      loginForm: {
        username: '',
        password: '',
        code:''
      },
      //手机登录
      phoneloginForm: {
        phone: '',
        codes:'',
        code:'',
        phoneinput:false,
        type:'2',//模板
        checked:false,
        CodeType:1,//0代表初始值,1代表直接输入电话或者邮箱，2代表用户获取
        GetType:1,//进行分类分解。int型，0代表初始值,1代表电话，2代表邮箱
      },
      rules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: Username
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: Password
        }],
        code: [{
          required: true,
          trigger: 'blur',
          validator: Code
        }],
      },
      //计时器
      content: '获取',
      totalTime: 60,
      canClick: true ,//添加canClick
      button_tof:false,
      //手机短信计时器
      phonecontent: '获取',
      phonetotalTime: 60,
      phonecanClick: true ,//添加canClick
      phonebutton_tof:false,
      //传回来的验证码
      getemailcode:'',
      getemail:'',
      //登录验证码
      logincode:{
        logincode:'',
        img:''
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.getlogincode();
  },
  //方法
  methods: {
    //确认协议
    update_check(){
      this.checked=true;
    },
    //登录调用协议页面
    login_reginster_ok(){
      this.$refs.childxieyiCheck.handleOpen();
    },
    //短信登录或注册
    phone_login_re(){
      let phonePD=/^1[3456789]\d{9}$/;
      if(this.phoneloginForm.phone.length<=0){
        this.$message({
          message: '请输入电话号码',
          type: 'error'
        });
        return false;
      }
      if(!phonePD.test(this.phoneloginForm.phone)){
        this.$message({
          message: '电话号码格式不正确',
          type: 'error'
        });
        return false;
      }
      if(this.phoneloginForm.code.length<=0){
        this.$message({
          message: '请输入短信验证码',
          type: 'error'
        });
        return false;
      }
      //协议区域
      if(!this.checked){
        this.login_reginster_ok();
        return false;
      }
      //！
      this.loading=true;
      //封装的公共请求API
      commonAPI('queryOK_or_NO', this.phoneloginForm).then(res => {
      let data = res.data;
      if(this.response.response_login(data)){
        sessionStorage.removeItem("store");
        sessionStorage.removeItem("token");//口令

        let datas = data.data.rows[0];
        this.UserInfor.id=datas.id;
        this.UserInfor.name=datas.name;
        this.UserInfor.sex=datas.sex;
        this.UserInfor.photo=datas.photo;
        this.UserInfor.phone=datas.phone;
        this.UserInfor.email=datas.email;
        this.UserInfor.signature=datas.signature;
        this.UserInfor.shop_type=datas.shop_type;
        this.UserInfor.token=datas.token;
        //this.saveLogining();
        this.saveLogin.saveLogining_user(this.UserInfor);
        //this.test()
        setTimeout(() => {
          this.loading = false;
          this.$router.go(0);
        },1000)
      }else{
        this.getlogincode();
        this.loading = false;
      }
      }).catch(error=>{
        //this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
        title: '提示',
        message: error.message,
        position: 'bottom-right',
        type: 'error'
      });
      })
    },
    //手机倒计时
    phonecountDown () {
     this.phoneloginForm.phoneinput = true;
     if (!this.phonecanClick) return  //改动的是这两行代码
     this.phonebutton_tof = true
     this.phonecanClick = false
     this.phonecontent = this.phonetotalTime
     let clock = window.setInterval(() => {
      this.phonetotalTime--
      this.phonecontent = this.phonetotalTime
      if (this.phonetotalTime <= 0) {
       window.clearInterval(clock)
       this.phonecontent = '获取'
       this.phonetotalTime = 60
       this.phonecanClick = true  //这里重新开启
       this.phonebutton_tof = false
       this.phoneloginForm.phoneinput = false;
      }
     },1000)
    },
    //获取手机验证码
    getPhoneCode(){
      let phonePD=/^1[3456789]\d{9}$/;
      if(this.phoneloginForm.phone.length<=0){
        this.$message({
          message: '请输入电话号码',
          type: 'error'
        });
        return false;
      }
      if(!phonePD.test(this.phoneloginForm.phone)){
        this.$message({
          message: '电话号码格式不正确',
          type: 'error'
        });
        return false;
      }
      if(this.phoneloginForm.codes.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      //判定验证码是否正确
      let codes=this.phoneloginForm.codes;
      let PD = eval(/^\d+$/);
      let codePD=this.logincode.logincode;
      if(PD.test(codePD)){
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD*1!==codes*1){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }else{
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD.toUpperCase()!==codes.toUpperCase()){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }
      this.phonecountDown();
      commonAPI('GetP_ECode', this.phoneloginForm).then(res => {
        this.getlogincode();
        let data=res.data
        if(this.response.response_code(data)){}
        //console.log(i)
      })
    },
    //跳转手机登录
    gotoQitaLogin(data){
      if(data=="phone"){
        document.getElementById('ptlogin').style.display='none';
        document.getElementById('ptlogin1').style.display='none';
        document.getElementById('other').style.display='block';
        document.getElementById('phonelogin').style.display='block';
      }else if(data=="wechat"){

      }else if(data=="QQ"){

      }else if(data=="back"){
        document.getElementById('ptlogin').style.display='block';
        document.getElementById('ptlogin1').style.display='block';
        document.getElementById('other').style.display='none';
        document.getElementById('phonelogin').style.display='none';
      }else{
        return false
      }
    },
    //进行会话存储
    setlocalStorage(key,value,time){
      let data={ value: value, expirse: new Date(time).getTime() };
      window.localStorage.setItem(key,JSON.stringify(data))
    },
    getlocalStorage(key){
      let data = JSON.parse(window.localStorage.getItem(key));
      if (data!=null||data!='') {
          if (data.expirse != null && data.expirse < new Date().getTime()) {
              window.localStorage.removeItem(key);
          } else {
              return data.value;
          }
          return null;
      }
    },
    //!会话存储结束
    //打开关闭忘记密码
    openPasswordMain(){
      document.getElementById('loginmain').style.display='none';
      document.getElementById('passwordMain').style.display='block';
    },
    //获取登录验证码方法
    getlogincode(){
      commonAPI('getLoginCodes', this.logincode).then(res => {
        let data=res.data
        this.logincode.logincode=data
        codeAPI('getLoginCode', this.logincode).then(res => {
          let url = window.URL.createObjectURL(res.data);
          this.logincode.img=url
          //console.log(url)
        })
      })
    },
    //登录信息的存储
    saveLogining(){
      sessionStorage.removeItem("store");
      sessionStorage.removeItem("token");//口令
      if(this.$store.state.u_id.length<=0){//只执行一次
        this.$store.commit({
          type:'changeUserInfor',
          u_token:this.UserInfor.token,
          u_id:this.UserInfor.id,
        });
      }else{
        this.$store.commit({
          type:'changeName_Photo',
          name:this.UserInfor.name,
          photo:this.UserInfor.photo
        });
      }
      sessionStorage.setItem("token",this.$store.state.u_token)//口令
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      //持久会话的存储
      window.localStorage.removeItem("store");
      window.localStorage.removeItem("token");
      let date = new Date().getTime();
      let daytime=86400000;//一天的时间，时间戳大小
      this.setlocalStorage("store",this.$store.state,date+daytime);//存储用户信息
      this.setlocalStorage("token",this.$store.state.u_token);//存储token
    },
    close(){
      document.getElementById('ptlogin1').style.display='block';
      document.getElementById('other').style.display='none';
      document.getElementById('ptlogin').style.display='block';
      document.getElementById('phonelogin').style.display='none';
      document.getElementById('loginmain').style.display='none';
      document.getElementById('zhedang').style.display='none';
      document.getElementById('registermain').style.display='none';
      document.getElementById('passwordMain').style.display='none';
    },
    openregister(){
      let u_id=this.UserInfor.id;
      if(u_id!=""){
        this.$notify({
        title: '提示',
        message: '你已经登录',
        position: 'bottom-right',
        type: 'success'
        });
      }else{
        document.getElementById('loginmain').style.display='none';
        document.getElementById('registermain').style.display='block';
        document.getElementById('zhedang').style.display='block';
      }
    },
    relogin(){//返回登录
      let u_id=this.UserInfor.id;
      if(u_id!=""){
        this.$notify({
        title: '提示',
        message: '你已经登录',
        position: 'bottom-right',
        type: 'success'
        });
      }else{
        this.openlogin();
        document.getElementById('registermain').style.display='none';
      }
    },
    //登录方法
    clickLogin(){
      //协议区域
      if(!this.checked){
        this.login_reginster_ok();
        return false;
      }
      //！
      this.$refs.loginForm.validate(valid => {
        if (valid) {//校验成功
          sessionStorage.removeItem("store");
          sessionStorage.removeItem("token");//口令
          this.loading = true;
          setTimeout(() => {//为了看到登录转圈圈的加载效果，这里来一个延迟2秒发送请求
            //密码加盐
            let pass=this.loginForm.password;
            this.loginForm.password=this.$md5(this.loginForm.password+this.usersalt);
            //封装的公共请求API
            commonAPI('UserLogin', this.loginForm).then(res => {
            let data = res.data;
            if(this.response.response_login(data)){
              let datas = data.data.rows[0];
              this.UserInfor.id=datas.id;
              this.UserInfor.name=datas.name;
              this.UserInfor.sex=datas.sex;
              this.UserInfor.photo=datas.photo;
              this.UserInfor.phone=datas.phone;
              this.UserInfor.email=datas.email;
              this.UserInfor.signature=datas.signature;
              this.UserInfor.shop_type=datas.shop_type;
              this.UserInfor.token=datas.token;
              //this.saveLogining();
              this.saveLogin.saveLogining_user(this.UserInfor);
              //this.test()
              setTimeout(() => {
                this.loading = false;
                this.$router.go(0);
              },1000)
            }else{
              this.getlogincode();
              this.loginForm.password=pass;
              this.loading = false;
            }
            }).catch(error=>{
              this.loginForm.password=pass;
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '登录提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
            }, 1000);
        }else{
          return false;
        }
      })
    },

  }
}
</script>

<style scoped>
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  .playlistbox_botton{
     width: 305px;
  	  margin: 0 auto;
  	  overflow: hidden;
  	  max-height: 300px;
     overflow-y: scroll;
   }

</style>



// WEBPACK FOOTER //
// src/components/LoginPage/loginpage_login.vue